{
    "Accessibility menu": "सुलभता मेनू",
    "Close": "बंद करें",
    "Content adjustments": "सामग्री समायोजन",
    "Navigation adjustments": "नेविगेशन समायोजन",
    "Text Align": "टेक्स्ट संरेखण",
    "Align Left": "बाईं ओर संरेखित करें",
    "Align Center": "केंद्र में संरेखित करें",
    "Align Right": "दाएं संरेखित करें",
    "Adjust Font Size": "फॉन्ट आकार समायोजित करें",
    "Highlight Title": "शीर्षक हाइलाइट करें",
    "Highlight Links": "लिंक हाइलाइट करें",
    "Readable Font": "पठनीय फॉन्ट",
    "Colour adjustments": "रंग समायोजन",
    "Dark Contrast": "गहरा कंट्रास्ट",
    "Light Contrast": "हल्का कंट्रास्ट",
    "High Contrast": "उच्च कंट्रास्ट",
    "High Saturation": "उच्च संतृप्ति",
    "Low Saturation": "कम संतृप्ति",
    "Monochrome": "मोनोक्रोम",
    "Tools": "उपकरण",
    "Reading Guide": "पठन मार्गदर्शिका",
    "Big Cursor": "बड़ा कर्सर",
    "Increase Font Size": "फॉन्ट आकार बढ़ाएं",
    "Decrease Font Size": "फॉन्ट आकार घटाएं",
    "Letter Spacing": "अक्षर रिक्ति",
    "Line Height": "पंक्ति ऊंचाई",
    "Font Weight": "फ़ॉन्ट मोटाई",
    "Dyslexia Font": "डिस्लेक्सिया फॉन्ट",
    "Language": "भाषा",
    "Accessibility widget": "सुलभता मेनू खोलें",
    "Accessibility Profiles": "सुलभता प्रोफ़ाइल",
    "Cognitive Disability": "संज्ञानात्मक विकलांगता",
    "Seizure Safe": "दौरा सुरक्षित",
    "Accessibility statement": "सुलभता विवरण",
    "ADHD": "ADHD",
    "Low Vision": "कम दृष्टि",
    "Pause Animations": "एनिमेशन रोकें",
    "Animation paused": "एनिमेशन रोका गया",
    "Reset all settings": "सेटिंग्स रीसेट करें",
    "Shortcut:": "शॉर्टकट:",
    "Epilepsy Safe Mode": "मिर्गी सुरक्षित मोड",
    "Mute sounds": "ध्वनि म्यूट करें",
    "Page read": "पेज पढ़ें",
    "Page read controls": "पेज पढ़ने के नियंत्रण",
    "Pause": "रोकें",
    "Resume": "फिर से शुरू करें",
    "Stop": "बंद करें",
    "Settings": "सेटिंग्स",
    "Speed": "गति",
    "Voice": "आवाज़",
    "Close accessibility menu": "सुलभता मेनू बंद करें",
    "Back to accessibility menu": "सुलभता मेनू पर वापस जाएं",
    "Search languages": "भाषाएं खोजें",
    "Selected language": "चयनित भाषा",
    "View accessibility statement (opens in new window)": "सुलभता विवरण देखें (नई विंडो में खुलता है)",
    "Visit CookieYes website (opens in new window)": "CookieYes वेबसाइट पर जाएं (नई विंडो में खुलता है)",
    "Reset all accessibility settings to default": "सभी सुलभता सेटिंग्स को डिफ़ॉल्ट पर रीसेट करें"
}
